export const counts = [
  { value: 1, id: 1 },
  { value: 2, id: 2 },
  { value: 3, id: 3 },
];

export const displays = [
  { value: "flex", id: 1 },
  //  { value: "grid", id: 2 }
];

export const directions = [
  { value: "row", id: 1 },
  { value: "column", id: 2 },
];

export const justifys = [
  { value: "center", id: 1 },
  { value: "space-between", id: 2 },
  { value: "space-around", id: 3 },
  { value: "space-evenly", id: 4 },
  { value: "flex-start", id: 5 },
  { value: "flex-end", id: 6 },
];

export const aligns = [
  { value: "center", id: 1 },
  { value: "flex-start", id: 2 },
  { value: "flex-end", id: 3 },
  { value: "stretch", id: 4 },
  { value: "baseline", id: 5 },
];

export const wraps = [
  { value: "wrap", id: 1 },
  { value: "no-wrap", id: 2 },
];

export const contents = [
  { value: "center", id: 1 },
  { value: "flex-start", id: 2 },
  { value: "flex-end", id: 3 },
  { value: "stretch", id: 4 },
  { value: "space-between", id: 5 },
  { value: "space-around", id: 6 },
  { value: "space-evenly", id: 7 },
];

export const selves = [
  { value: "center", id: 1 },
  { value: "flex-start", id: 2 },
  { value: "flex-end", id: 3 },
  { value: "stretch", id: 4 },
  { value: "baseline", id: 5 },
];

export const flexes = [
  { value: "1 1 auto", id: 1 },
  { value: "0", id: 2 },
];
